/**
 * I salvataggi dell'editor ancora in viaggio, e il modo di aspettarli.
 *
 * Nell'editor del preventivo quasi ogni campo si salva quando lo si lascia
 * (onBlur). Il clic su «Pubblica» toglie il fuoco dall'ultimo campo scritto:
 * il suo salvataggio parte in quello stesso istante, e il controllo di
 * pubblicazione partiva insieme a lui. Visto il 24-09 sulla rete: PATCH e
 * «valida-per-invio» a un millisecondo l'uno dall'altro. Se il controllo
 * arriva prima, dice che manca una cosa che a schermo è compilata.
 *
 * Chi salva registra la sua promessa; chi pubblica aspetta che non ce ne
 * siano più in viaggio.
 */
const inViaggio = new Set();

export function registraSalvataggio(promessa) {
  inViaggio.add(promessa);
  const togli = () => inViaggio.delete(promessa);
  promessa.then(togli, togli);
  return promessa;
}

export async function attendiSalvataggi() {
  // Se il fuoco è ancora in un campo (si pubblica da tastiera), lo si toglie:
  // il suo onBlur registra il salvataggio.
  const attivo = typeof document !== "undefined" ? document.activeElement : null;
  if (attivo && attivo !== document.body && typeof attivo.blur === "function") attivo.blur();
  // Un giro di eventi, perché gli onBlur scattati adesso facciano partire la loro chiamata.
  await new Promise((fatto) => setTimeout(fatto, 0));
  while (inViaggio.size) {
    await Promise.allSettled([...inViaggio]);
  }
}

export function salvataggiInViaggio() {
  return inViaggio.size;
}
